
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressCorporateFR]",
      function () {
        return require("private-next-pages/[...wordpressCorporateFR].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressCorporateFR]"])
      });
    }
  